import API from '../../../services/Api'

export const sendMail = (event, captcha, setState) => {
  event.preventDefault()
  setState({ loading: true })
  API.post('/api/v1/auth/passwordrecover', { email: event.target.email.value, reCaptcha: captcha })
    .then((res) => setState({ success: true }))
    .catch((err) => setState({ failed: true }))
}
